import { Component, Input, OnInit } from "@angular/core";
import { Wiring } from "../../../../../codegen/out/types";

@Component({
  selector: "app-ru-x-2-wiring-diagram",
  templateUrl: "./ru-x-2-wiring-diagram.component.html",
  styleUrls: ["./ru-x-2-wiring-diagram.component.scss"],
  standalone: false,
})
export class RuX2WiringDiagramComponent implements OnInit {
  @Input() wiring: Wiring;

  terminals = {};

  ngOnInit(): void {
    for (const terminal of this.wiring.terminals) {
      this.terminals[terminal.device] = terminal;
    }
  }
}
